import { httpService, HttpTask } from '@core/http';
import { Sensoterra } from '@modules/iot/sensoterra/model';
import { PendingSensor, Sensor } from '@modules/iot/sensors/model';
import { Measures } from '@shared/modules/measures/model';

export namespace SensoterraService {
  const URI = '/iot/sensors/sensoterra';

  export function updatePending(params: Sensoterra.PendingParams): HttpTask<PendingSensor.RegisterSensorOut> {
    return httpService.post(URI, params);
  }

  export function getHumidityMeasures(id: Sensor.Id, filter: Sensoterra.Humidity.Filter): HttpTask<Measures.Humidity> {
    return httpService.get(`${URI}/${id}/measures/humidity`, { params: filter });
  }

  export function updateSensor(id: Sensor.Id, params: Sensoterra.UpdateParams): HttpTask {
    return httpService.post(`${URI}/${id}/config`, params);
  }
}
